import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Collapse from 'react-bootstrap/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

import sides from 'shared/product_tabs/tab_stencils/data/stencilSides';
import { deleteStencil } from 'shared/product_tabs/tab_stencils/slice/stencilsSlice';
import { selectStencilsType, selectStencilsSide } from 'shared/product_tabs/tab_stencils/slice/selectors';
import { getStencilsTitle } from 'shared/product_tabs/tab_stencils/slice/utils/getStencilsTitle';

const Stencils = (props) => {
  const { subTotal, quantity, selected } = props;
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const stencilsType = useSelector(selectStencilsType);
  const stencilsSide = useSelector(selectStencilsSide);

  if (!selected) return null;

  const selectedStencilInfo = Spree.stencils_info.find((info) => info.slug === stencilsType);
  const stencilsTypeDesc = selectedStencilInfo ? selectedStencilInfo.name : stencilsType;

  const selectedStencilSide = sides.find((side) => side.key === stencilsSide);
  const stencilsSideDesc = selectedStencilSide ? selectedStencilSide.label : stencilsSide;

  const onDelete = () => {
    dispatch(deleteStencil());
    setOpen(false);
  };
  const onToggle = () => setOpen(!open);

  return (
    <div className="cart-section stencils">
      <div className="title">
        {getStencilsTitle(stencilsSide)} SMT Stencils
        {quantity !== undefined ? ` X ${quantity}` : null}

        <button type="button" onClick={onDelete} className="btn btn-link float-right btn-delete">
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="position-relative">
        <div className="price">
          {subTotal === undefined ? null : `$${subTotal}`}
        </div>
        <div className="toggle-details">
          <button type="button" className="btn btn-link p-0" onClick={onToggle}>
            {open ? Spree.translations.view_less : Spree.translations.view_more}
          </button>
        </div>
        <Collapse in={open}>
          <div>
            <div className="details">
              <div className="detail">
                <strong>Type:</strong> {stencilsTypeDesc}
              </div>
              <div className="detail">
                <strong>Sides:</strong> {stencilsSideDesc}
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

Stencils.propTypes = {
  subTotal: PropTypes.number,
  quantity: PropTypes.number,
  selected: PropTypes.bool,
};

Stencils.defaultProps = {
  subTotal: undefined,
  quantity: undefined,
  selected: false,
};

export default Stencils;
